import TabsNavContainer from "components/shared/TabsNavContainer";
import TabLink from "hardcover-ui/components/TabLink";

export default function UserPromptNav({ username }: { username: string }) {
  return (
    <TabsNavContainer>
      <TabLink href={`/@${username}/prompts/answered`} size="sm">
        <>Answered Prompts</>
      </TabLink>
      <TabLink href={`/@${username}/prompts/asked`} size="sm">
        <>Asked Prompts</>
      </TabLink>
    </TabsNavContainer>
  );
}
